import { useCallback } from 'react';

import {
  GasFeePreset,
  settingsSelector,
  useMarketTradeSettingsStore,
} from '@/store/tradeSettings/market';

type GasSettings = {
  gasFeePreset?: GasFeePreset;
  gasPrice?: string;
  baseFee?: string;
  priorityFee?: string;
};

export default function useGasSettings({ chainId }: { chainId: number }) {
  const {
    settings: { gasFeePreset, baseFee, priorityFee, gasPrice },
    setSettings,
  } = useMarketTradeSettingsStore(settingsSelector(chainId));

  const setGas = useCallback(
    (gasSettings: GasSettings) => {
      setSettings({
        ...gasSettings,
      });
    },
    [setSettings],
  );

  return {
    gasFeePreset,
    baseFee,
    priorityFee,
    gasPrice,
    setGas,
  };
}
